module.exports = __webpack_public_path__ + "static/media/Travel.ad550467.jpg";